"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InvoiceAttributesSchema = exports.InvoiceBillingReasons = exports.InvoicePaymentStatus = void 0;
const zod_1 = require("zod");
exports.InvoicePaymentStatus = {
    OPEN: 'open',
    PAID: 'paid',
    VOID: 'void',
    EXPIRED: 'expired',
};
exports.InvoiceBillingReasons = {
    RENTAL_ORDER: 'rental_order',
};
exports.InvoiceAttributesSchema = zod_1.z.object({
    id: zod_1.z.number(),
    orderId: zod_1.z.number(),
    status: zod_1.z.nativeEnum(exports.InvoicePaymentStatus),
    billingReason: zod_1.z.nativeEnum(exports.InvoiceBillingReasons),
    postedDate: zod_1.z.date(),
    dueDate: zod_1.z.date(),
    memo: zod_1.z.string(),
    hostedInvoiceUrl: zod_1.z.string().nullable().optional(),
    pdfUrl: zod_1.z.string().nullable().optional(),
    customerName: zod_1.z.string(),
    customerPhone: zod_1.z.string(),
    customerEmail: zod_1.z.string(),
    deliveryAddress: zod_1.z.string(),
    subtotal: zod_1.z.number(),
    tax: zod_1.z.number(),
    total: zod_1.z.number(),
    discount: zod_1.z.number(),
});
//# sourceMappingURL=invoice.js.map